import {
  WhatMakesDifferentSection,
  OurPromiseSection,
  CustomerSolutionsSection,
  TestimonialsSection,
  StatsSection,
  TechInnovationSection,
  EnvironmentalSection,
} from "@features/residential/components";

interface WhyChooseGasisPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function WhyChooseGasisPage({ hero, footer }: WhyChooseGasisPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <WhatMakesDifferentSection />
      <OurPromiseSection />
      <CustomerSolutionsSection />
      <TestimonialsSection />
      <StatsSection />
      <TechInnovationSection />
      <EnvironmentalSection />
      {footer}
    </div>
  );
}
